import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { GROUP_BOX_PADDING_LEFT_RIGHT } from '@atlassian/help-center-common-component/group-box';

// eslint-disable-next-line rulesdir/no-styled-export
export const NoArticleHelpText = styled.div`
    ${fonts.regular};
    margin-bottom: ${token('space.100', '8px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ArticleOrderedList = styled.ol`
    margin: 0 -${GROUP_BOX_PADDING_LEFT_RIGHT};
    padding: 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const SectionHeading = styled.h2`
    ${fonts.h500};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ArticleListContainer = styled.div<{ marginTop: boolean }>`
    margin-top: ${(props) => (props.marginTop ? token('space.200', '16px') : 0)};

    > * {
        /* This will add a magin to all first level children of this container. */
        margin-top: ${token('space.200', '16px')};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const NoArticlesContainer = styled.div`
    margin-bottom: ${token('space.500', '40px')};
`;
